import BaseModel from "../../common/model/BaseModel";
import BaseCall from "../../common/model/BaseCall";

export default class ResourceDown extends BaseModel {

    /**
     * 首页本周上周统计记录
     */
    static getExtraResource(params, fn) {
        BaseCall.get('getExtraResource', {params: params}, ({type, data}, res) => {
            let list = data.data
            typeof fn === 'function' ? fn({type, list}) : '';
        });
    }
}
